import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const defaultOptions = {
  automaticLayout: true,
  fontFamily: token('font.family.code'),
  fontSize: 13,
  hideCursorInOverviewRuler: true,
  lineDecorationsWidth: gridSize(),
  // The gutter only really fits N-1 characters due to `lineDecorationsWidth`
  lineNumbersMinChars: 6,
  matchBrackets: false,
  occurrencesHighlight: false,
  // Required even though the docs say it defaults to `false`
  renderIndentGuides: false,
  renderLineHighlight: 'none',
  scrollBeyondLastLine: false,
  selectionHighlight: false,
  // We handle this ourselves
  selectOnLineNumbers: false,
};

export const editorOptions = {
  // Right-click menu ("Go To Definition", "Rename Symbol", Cut/Copy/Paste, etc)
  contextmenu: true,
  // Show hints/info upon hovering over symbols with identified problems
  hover: true,
  minimap: { enabled: true },
  // Improve auto-complete suggestions (e.g., understanding string union types in TypeScript files)
  // Required even though the docs say it defaults to `true`
  quickSuggestions: true,
  readOnly: false,
};

export const readOnlyOptions = {
  contextmenu: false,
  hover: false,
  minimap: { enabled: false },
  readOnly: true,
};
